import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface GradientOrColourState {
  filteredColourTheories: string[];
  showColours: boolean;
  showAccent: boolean;
  isOpen: boolean;
  isOpenCG: boolean;
  isOpenSort: boolean;
  hueWiseSorting: boolean;
  saturationWiseSorting: boolean;
  luminosityWiseSorting: boolean;
  showLightAccent: boolean;
  showDarkAccent: boolean;
  showBoth: boolean;
}
const initialState: GradientOrColourState = {
  filteredColourTheories: [],
  showColours: true,
  showAccent: false,
  isOpen: false,
  isOpenSort: false,
  hueWiseSorting: true,
  saturationWiseSorting: false,
  luminosityWiseSorting: false,
  isOpenCG: false,
  showLightAccent: false,
  showDarkAccent: false,
  showBoth: false,
};

export const sortedSlice = createSlice({
  name: "sorting",
  initialState,
  reducers: {
    setShowColour: (state) => {
      state.showColours = true;
      state.showBoth = false;
      state.showLightAccent = false;
      state.showDarkAccent = false;
      state.showAccent = false;
    },
    addFilteredColourTheories: (state, action: PayloadAction<string>) => {
      state.filteredColourTheories.push(action.payload);
    },
    removeFilteredColourTheories: (state, action: PayloadAction<string>) => {
      const index = state.filteredColourTheories.indexOf(action.payload);
      if (index > -1) {
        state.filteredColourTheories.splice(index, 1);
      }
    },
    setShowGradient: (state) => {
      state.showColours = false;
      state.showAccent = false;
      state.showBoth = false;
      state.showLightAccent = false;
      state.showDarkAccent = false;
    },
    toggleShowBoth: (state) => {
      state.showAccent = false;
      state.showBoth = !state.showBoth;
      state.showLightAccent = false;
      state.showDarkAccent = false;
    },
    toggleShowAccent: (state) => {
      state.showAccent = !state.showAccent;
    },
    toggleShowLightAccent: (state) => {
      state.showLightAccent = !state.showLightAccent;
      state.showAccent = false;
      state.showDarkAccent = false;
    },
    toggleShowDarkAccent: (state) => {
      state.showDarkAccent = !state.showDarkAccent;
      state.showAccent = false;
      state.showLightAccent = false;
    },
    toggleGradientOrColourValue: (state) => {
      state.showColours = !state.showColours;
    },
    toggleIsOpen: (state) => {
      state.isOpen = !state.isOpen;
    },
    toggleIsOpenCG: (state) => {
      state.isOpenCG = !state.isOpenCG;
    },
    toggleIsOpenSort: (state) => {
      state.isOpenSort = !state.isOpenSort;
    },
    backdropClick: (state) => {
      state.isOpen = false;
      state.isOpenSort = false;
      state.isOpenCG = false;
    },
    toggleLuminosityWiseSorting: (state) => {
      state.luminosityWiseSorting = !state.luminosityWiseSorting;
      state.saturationWiseSorting = false;
      state.hueWiseSorting = false;
    },
    toggleSaturationWiseSorting: (state) => {
      state.saturationWiseSorting = !state.saturationWiseSorting;
      state.luminosityWiseSorting = false;
      state.hueWiseSorting = false;
    },
    toggleHueWiseSorting: (state) => {
      state.hueWiseSorting = !state.hueWiseSorting;
      state.saturationWiseSorting = false;
      state.luminosityWiseSorting = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setShowColour,
  addFilteredColourTheories,
  removeFilteredColourTheories,
  setShowGradient,
  toggleIsOpen,
  toggleIsOpenCG,
  toggleShowLightAccent,
  toggleHueWiseSorting,
  toggleSaturationWiseSorting,
  toggleIsOpenSort,
  toggleLuminosityWiseSorting,
  toggleShowDarkAccent,
  backdropClick,
  toggleShowAccent,
  toggleShowBoth,
  toggleGradientOrColourValue,
} = sortedSlice.actions;

export default sortedSlice.reducer;
